import { inject, provideEnvironmentInitializer } from '@angular/core';
import { ApplicationStore, getModuleGroupByName, SOFTLINE_FEATURE_APPLICATIONS } from '@softline/application';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { archivbelegUploadRoutes } from './archivbeleg-upload.routes';
import { SOFTLINE_PERMISSION_UPLOAD_ARCHIVE_VOUCHER } from './archivbeleg-upload.shared';

export const archivbelegUploadProviders = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'archivbeleg',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'Archivbeleg hochladen',
      icon: 'fa-regular fa-file-arrow-up',
      route: '/archivbeleg',
      permission: SOFTLINE_PERMISSION_UPLOAD_ARCHIVE_VOUCHER,
      group: getModuleGroupByName('Stammdaten'),
    });
  }),
];

export function provideArchivbelegUploadModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'wws/archivbeleg-upload',
        title: '#UPLOAD_ARCHIVE_VOUCHER.TITLE',
        icon: 'fa-regular fa-file-arrow-up',
        route: '/archivbeleg',
        permission: SOFTLINE_PERMISSION_UPLOAD_ARCHIVE_VOUCHER,
        group: getModuleGroupByName('Stammdaten'),
      },
      withSoftAppsModuleRoutes({ app: archivbelegUploadRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/wws/archivbeleg-upload',
        description: 'Archivbelege hochladen.',
      })
    ),
  ];
}
